













































import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';
import VatsGoogleMap from '@/Shared/VatsGoogleMaps/VatsGoogleMap.vue';
import VatsAPI from '@/Shared/VatsAPI';
import { Logger } from '@/Shared/Logger';
import { mapGetters } from 'vuex';
import { LPRItem } from './LPRItem';

const LPRAnalysis = mixins(LocationBasedMixin).extend({
  components: {
    VatsGoogleMap
  },
  data() {
    return {
      mapConfig: {} as google.maps.MapOptions,
      file: (undefined as unknown) as File,
      heatmapData: [] as google.maps.LatLngLiteral[],
      mapImageSrc: ''
    };
  },
  watch: {
    file() {
      this.preview();
    }
  },
  computed: {
    ...mapGetters('loaderModule', ['loading'])
  },
  async mounted() {
    await this.init();
  },
  methods: {
    locationChanged() {
      this.init();
    },
    async init() {
      const latLongString = (
        await VatsAPI.get<string>(
          `/${this.location}/lotmaintenance/GetLatLongForLocation`
        )
      ).data;

      const latLongArr = latLongString.split(',');
      const latLongObj: google.maps.LatLngLiteral = {
        lat: parseFloat(latLongArr[0]),
        lng: parseFloat(latLongArr[1])
      };

      this.mapConfig = {
        zoom: 14,
        mapTypeId: 'roadmap',
        center: latLongObj
      };
    },
    async preview() {
      const formData = new FormData();
      formData.append('file', this.file, this.file.name);

      const result = await VatsAPI.post<LPRItem[]>(`/${this.location}/LPRAnalysis/preview`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      const resultArray = result.data as any[];
      this.heatmapData = resultArray.map((item) => ({lat: item.latitude, lng: item.longitude}));
    },
    async runReport(imageData: string) {
      const formData = new FormData();
      formData.append('file', this.file, this.file.name);

      const result = await VatsAPI.post<LPRItem[]>(`/${this.location}/LPRAnalysis/run`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    },
    async save() {
      const formData = new FormData();
      formData.append('file', this.file, this.file.name);

      const result = await VatsAPI.post<LPRItem[]>(`/${this.location}/LPRAnalysis/import`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
  }
});

export default LPRAnalysis;
